import { render, staticRenderFns } from "./Chartjs.vue?vue&type=template&id=80b2d712&scoped=true&"
import script from "./Chartjs.vue?vue&type=script&lang=js&"
export * from "./Chartjs.vue?vue&type=script&lang=js&"
import style0 from "./Chartjs.vue?vue&type=style&index=0&id=80b2d712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b2d712",
  null
  
)

export default component.exports